import { formatCnpj, sanitizeCnpj } from '@/helpers/cnpj'

export default value => {
  if (value === null || value === undefined || value === '') return '-'
  const raw = sanitizeCnpj(value)
  if (!raw) return '-'
  return formatCnpj(raw)
}
